import styled from 'styled-components';

import {
  Input as SemanticInput,
  Select as SemanticSelect,
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, Header as HeaderLayoutComponent, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    padding: 30px;
    width: 600px;
  }
`;

export const Text = styled(TextLayoutComponent)``;

export const Bold = styled(Text.Bold)`
  margin-bottom: 5px;
`;

export const EmailBold = styled(Text.Bold)`
  margin-bottom: 5px;
  width: 90px;
  margin-right: -4px
`;

export const FirstNameBold = styled(Text.Bold)`
  margin-bottom: 5px;
  width: 90px
`;

export const LastNameBold = styled(Text.Bold)`
  margin: 0;
  width: 70px
`;

export const Header = styled(HeaderLayoutComponent)``;

export const Link = styled.a``;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    align-self: center;
    width: 100px;
    margin: 10px 0;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  p {
    margin-bottom: 0 !important;
  }
`;

export const Email = styled(SemanticInput)`
  flex: 1;
  margin-left: 1em;
`;

export const Country = styled(SemanticSelect)`
  flex: 1;
  margin-left: 1em;
`;

export const NameInput = styled(SemanticInput)`
  flex: 0.5;
  margin-left: 1em;
  margin-right: 4px;
`;

export const ErrorMessage = styled(TextLayoutComponent)`
  color: ${({ theme }) => theme.color.error};
  font-weight: 500;
  padding-top: 10px;
  align-self: center;
`;

export const Checkbox = styled(SemanticCheckbox)`
  &.ui.checkbox {
    margin: 2px 0;
    label {
      color: ${(props) => props.theme.color.textLabel};
      margin-right: 10px;
    }
    input:focus~label {
      color: ${(props) => props.theme.color.textLabel};
    }
  }
`;
